// src/components/ui/Modal.jsx
// Использование:
//   <Modal isOpen={showModal} onClose={() => setShowModal(false)} title="Новый договор">
//     <p>Содержимое модального окна</p>
//   </Modal>
//
//   // Без заголовка (кастомный header внутри children):
//   <Modal isOpen={showModal} onClose={onClose}>
//     <div className="flex justify-between">...</div>
//   </Modal>
//
//   // Максимальная ширина:
//   <Modal isOpen={open} onClose={onClose} title="Настройки" maxWidth="max-w-lg">
//     ...
//   </Modal>
//
//   // Без кнопки закрытия (например, подписание — нельзя закрыть кликом вне):
//   <Modal isOpen={open} onClose={null} title="Подписание">
//     ...
//   </Modal>

import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { Button } from './Button';

export const Modal = ({
  isOpen = false,
  onClose,
  title,
  children,
  maxWidth = 'max-w-md',
  className = '',
}) => {
  // Закрытие по Escape
  useEffect(() => {
    if (!isOpen || !onClose) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handler);
    return () => window.removeEventListener('keydown', handler);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[9999] bg-gray-50/80 backdrop-blur-sm flex items-center justify-center p-6"
      onClick={(e) => { if (e.target === e.currentTarget && onClose) onClose(); }}
    >
      <div
        className={`
          w-full ${maxWidth}
          bg-white border border-gray-200 rounded-3xl p-8
          shadow-2xl text-gray-900 space-y-6
          ${className}
        `}
      >
        {/* Заголовок — только если передан title или onClose */}
        {(title || onClose) && (
          <div className="flex items-center justify-between">
            {title && (
              <h3 className="font-black text-lg uppercase italic">{title}</h3>
            )}
            {onClose && (
              <Button
                variant="icon"
                onClick={onClose}
                className="ml-auto flex-shrink-0"
              >
                <X size={20} />
              </Button>
            )}
          </div>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
};
